import CommonService from "../Common";
import { AxiosRequestConfig } from "axios";

interface Subscription {
  pathPrefix?: string;
  commonService: CommonService;
}

interface SubscriptionData {
  userId: string;
  subscriptionPlan:
    | string
    | "starterPlan"
    | "growthPlan"
    | "proPlan"
    | "scalePlan"
    | any;
}

class SubscriptionService implements Subscription {
  pathPrefix?: string;
  commonService: CommonService;

  constructor() {
    this.pathPrefix = "/api/v1/subscriptions";
    this.commonService = new CommonService();
  }

  // Join or update subscription
  joinOrUpdateSubscription(subscriptionData: SubscriptionData) {
    const config: AxiosRequestConfig = {
      method: "PUT",
      url: this.pathPrefix,
      data: subscriptionData,
      withCredentials: true,
    };
    return this.commonService.fetch(config);
  }

  // Get subscription details
  getSubscription(userId: string) {
    const config: AxiosRequestConfig = {
      method: "GET",
      url: `${this.pathPrefix}/${userId}`,
      withCredentials: true,
    };
    return this.commonService.fetch(config);
  }
}

export default SubscriptionService;
